import { BASE_URL } from "../../../shared/utils/variables";
import { getAuthHeaders } from "../../../shared/services/authentication";

const baseURL = BASE_URL;

export const fetchRubricas = async () => {
    console.log('📋 [RubricaService] fetchRubricas chamado');
    
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(`${baseURL}/rubricas`, options);
        const data = await response.json();

        console.log('✅ [RubricaService] fetchRubricas sucesso:', data);
        return data;
    } catch (error) {
        console.error('❌ [RubricaService] Erro ao buscar rubricas:', error);
        throw error;
    }
}

export const fetchRubricaService = async (id: string) => {
    console.log('📋 [RubricaService] fetchRubricaService chamado para ID:', id);
    
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(`${baseURL}/rubrica/${id}`, options);
        const data = await response.json();
        
        console.log('✅ [RubricaService] fetchRubricaService sucesso:', data);
        return data;
    } catch (error) {
        console.error('❌ [RubricaService] Erro ao buscar rubrica:', error);
        throw error;
    }
}

export const fetchRubricasGrouped = async () => {
    console.log('📋 [RubricaService] fetchRubricasGrouped chamado');
    
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(`${baseURL}/rubricas-grouped`, options);
        const data = await response.json();

        console.log('✅ [RubricaService] fetchRubricasGrouped sucesso:', data);
        return data;
    } catch (error) {
        console.error('❌ [RubricaService] Erro ao buscar rubricas agrupadas:', error);
        throw error;
    }
}

export interface CreateRubricaDTO {
    name: string;
    description?: string;
    clientId: string;
}

export const createRubrica = async (rubrica: CreateRubricaDTO) => {
    console.log('🆕 [RubricaService] createRubrica chamado');
    console.log('🆕 [RubricaService] Payload:', rubrica);
    console.log('🆕 [RubricaService] URL:', `${baseURL}/rubrica`);
    
    const options = {
        method: 'POST',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(rubrica) // ⚠️ CORRIGIDO: Adicionado o body que estava faltando!
    };

    console.log('🆕 [RubricaService] Headers:', options.headers);
    console.log('🆕 [RubricaService] Body:', options.body);

    try {
        const response = await fetch(`${baseURL}/rubrica`, options);
        
        console.log('🆕 [RubricaService] Response status:', response.status);
        console.log('🆕 [RubricaService] Response ok:', response.ok);
        
        if (!response.ok) {
            const errorData = await response.json();
            console.error('❌ [RubricaService] Erro na resposta:', errorData);
            throw {
                response: {
                    data: errorData,
                    status: response.status
                }
            };
        }
        
        const data = await response.json();

        console.log('✅ [RubricaService] createRubrica sucesso:', data);
        return data;
    } catch (error) {
        console.error('❌ [RubricaService] Erro ao criar rubrica:', error);
        throw error;
    }
}

// Função adicional para buscar rubricas por cliente
export const fetchRubricasByClient = async (clientId: string) => {
    console.log('📋 [RubricaService] fetchRubricasByClient chamado para clientId:', clientId);
    
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(`${baseURL}/rubricas?clientId=${clientId}`, options);
        const data = await response.json();

        console.log('✅ [RubricaService] fetchRubricasByClient sucesso:', data);
        return data;
    } catch (error) {
        console.error('❌ [RubricaService] Erro ao buscar rubricas do cliente:', error);
        throw error;
    }
}